import { Meeting } from '@mekimix/shared/src/types/Meeting'
import { MeetingFormValues } from '../features/calendar/schemas/newMeetingSchema';
import { baseApi } from '../app/baseApi';


export const calendarApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getMeetingsByDay: builder.query<Meeting[], { mentorId: string; date: string }>({
            query: ({ mentorId, date }) => ({
                url: `calendar/day`,
                method: 'GET',
                params: { mentorId, date },
            }),
            providesTags: ['Calendar'],
        }),
        getMeetingsByMonth: builder.query<Meeting[], { mentorId: string; month: string }>({
            query: ({ mentorId, month }) => ({
                url: 'calendar/month',
                method: 'GET',
                params: { mentorId, month },
            }),
            providesTags: ['Calendar'],
        }),
        addNewMeeting: builder.mutation<void, MeetingFormValues>({
            query: (body) => ({
            url: 'calendar/',
            method: 'POST',
            body,
           }),
           invalidatesTags: ['Calendar'],
        }),
       editMeeting: builder.mutation<void, { id: string; data: Partial<Meeting> }>({
           query: ({ id, data }) => ({
           url: `calendar/${id}`,
           method: 'PATCH',
           body: data,
         }),
         invalidatesTags: ['Calendar'],
        }),
       deleteMeeting: builder.mutation<void, string>({
          query: (id) => ({
          url: `calendar/${id}`,
           method: 'DELETE',
         }),
         invalidatesTags: ['Calendar'],
        }),
    }),
})
export const {
    useGetMeetingsByDayQuery,
    useGetMeetingsByMonthQuery,
    useAddNewMeetingMutation,
    useEditMeetingMutation,
    useDeleteMeetingMutation,
} = calendarApi;